import { bestAuctions, bestAuctions_en } from '../../constant';

import SectionHeader from '../ui/SectionHeader';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuctionCard from '../ui/AuctionCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Auction } from '../../types';

const NewAuction = () => {
    const { t, i18n } = useTranslation();
    const newAuctions:Auction[] = i18n.language === "ar" ? bestAuctions : bestAuctions_en;
/*    
    ///////remove this comment to fetch plans from backend//////
    const [newAuctions, setNewAuctions] = useState< Auction[]>([]);
    useEffect(() => {
        const loadNewAuctions = async () => {
            try {
                const data = await fetchNewestAuctions();
                setNewAuctions(data);
            } catch (error) {
                toast.error('Failed to fetch plans.');
            }
        };
        loadNewAuctions();
    }, []);   */
    return (
        <section className='pb-20 ' id="latest-auctions">
            <div className='max-container padding-container'>
                <SectionHeader title={t("new-auction")} />
                <div >
                    <Swiper
                        spaceBetween={20}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                            },
                            640: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            1024: {
                                slidesPerView: 3,
                            },
                        }}
                        dir={i18n.language === "ar" ? "rtl" : "ltr"}
                    >
                        {newAuctions.map((item: any, index: number) => (
                            <SwiperSlide key={index}>

                                <AuctionCard item={item} />

                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className='grid pt-4 text-blue-500 text-lg'>
                    <Link to={"#"} className=' justify-self-end underline'>{t("see-all")}</Link>
                </div>
            </div>
        </section>
    )
}

export default NewAuction
